import React from 'react';
import DataCache from "../../StaticData/StaticDataCache";
import ScheduleTask from "../../../Common/Models/ScheduleTask";
import { CatalogueEntry } from "../CatologueEntry";
import { IGeneralApiClient } from '../../../Common/ApiClients/GeneralApiClient';
import { Model } from '@singularsystems/neo-core';
import { NeoGrid } from '@singularsystems/neo-react';
import { Catalogue } from '@singularsystems/neo-react-services';
import * as Roles from "../../../AccessControl/Models/Commands/Security/Roles"


export default class ScheduleTaskCatalogueEntry extends CatalogueEntry<ScheduleTask> {

    constructor() {
        super("Schedule Task", ScheduleTask);
    }

    public getCacheEntry(cache: DataCache) {
        return cache.scheduleTasks;
    }

    public get editRole() {
        return Roles.CatalogueRoles.Edit;
    }

    public getSaveEndpoint(apiClient: IGeneralApiClient) {
        return apiClient.getScheduleTasksList;
    }

    public renderRow(item: ScheduleTask, meta: Model.TransformMetaType<ScheduleTask>) {
        return (
            <NeoGrid.Row>
                <NeoGrid.Column bind={meta.command} />
                <NeoGrid.Column bind={meta.scheduledDateTime} />
                <NeoGrid.Column bind={meta.executionDateTime} />
                <NeoGrid.Column bind={meta.executionCompleteDateTime} />
                <Catalogue.ButtonColumn />
            </NeoGrid.Row>
        )
    }
}